import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { selectUserIsIdentified } from 'core/selectors/user';
import {
  useTriggerInstoreDetailsIsViewedGaEvent,
} from 'core/modules/Instore2/hooks/useTriggerInstoreDetailsIsViewedGaEvent';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import AnonymousView from 'core/modules/Instore2/components/InstoreOfferDetails/components/AnonymousView';
import WithLinkedCardsView from 'core/modules/Instore2/components/InstoreOfferDetails/components/WithLinkedCardsView';
import WithoutLinkedCardsView
  from 'core/modules/Instore2/components/InstoreOfferDetails/components/WithoutLinkedCardsView';
import WithoutAnyCardsView from 'core/modules/Instore2/components/InstoreOfferDetails/components/WithoutAnyCardsView';
import { ME_PAGE_INSTORE_ONLY } from 'core/modules/Instore2/utils/constants';

function InstoreOnlyMeOfferDetails({ offer }) {
  const isUserIdentified = useSelector(selectUserIsIdentified);

  useTriggerInstoreDetailsIsViewedGaEvent(offer, ME_PAGE_INSTORE_ONLY);

  if (isEmpty(offer)) {
    return null;
  }

  const { hasEligibleCards, hasLinkedCards } = offer;

  if (!isUserIdentified) {
    return <AnonymousView offer={offer} />;
  }

  if (hasLinkedCards) {
    return <WithLinkedCardsView offer={offer} />;
  }

  if (hasEligibleCards && !hasLinkedCards) {
    return <WithoutLinkedCardsView offer={offer} />;
  }

  return <WithoutAnyCardsView offer={offer} />;
}

export default (props) => <ComponentErrorBoundary><InstoreOnlyMeOfferDetails {...props} /></ComponentErrorBoundary>;
